import { JsonProperty, JsonObject } from 'json2typescript';
import { EmptyControl } from '@hvlng/framework-bff/core';
import { CodeTextQueryModel } from '../../code-text/model/code-text-query-model';

@JsonObject('KovanHrPerSocialSecuritySubtypeQueryModel')
export class PerSocialSecuritySubtypeQueryModel extends CodeTextQueryModel {
    @EmptyControl()
    @JsonProperty('uuidList', [String], true)
    uuidList: Array<string> = null;

    @EmptyControl()
    @JsonProperty('perIdentificationSubtypeId', Number, true)
    perIdentificationSubtypeId: number = null;
}
